import { ExternalLink } from "@sundae/ui-toolkit";
import { FC, memo } from "react";
import { Trans } from "react-i18next";
import { externalRoutes } from "../../../../pages/routes";

const TasteTestPersonalization: FC = () => {
  return (
    <Trans i18nKey="detail.personalization" ns="taste-test">
      This Taste Test uses custom colors from a personalized ADA Handle. Read more about it{" "}
      <ExternalLink
        arrow="top-right"
        size="xs"
        href={externalRoutes.handlePersonalization}
        variant="primary"
      >
        here
      </ExternalLink>
    </Trans>
  );
};

export default memo(TasteTestPersonalization);
